import React, { useEffect } from "react";
import { BundleInterface } from "src/store/callrecorder/bundlesSlice";

import { Button, Form, Input, Switch } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: BundleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='name' label="Name">
        <Input disabled={!!params?.id} />
      </Form.Item>

      <Form.Item name='twilio_service_sid' label="Twilio Service SID">
        <Input />
      </Form.Item>

      <Form.Item name='shared_secret' label="Shared Secret">
        <Input />
      </Form.Item>

      <h6 className="v-content-label o-sm">
        Voip Certificate
      </h6>

      <FileDropzone name='voip_cert' label='Voip Cert' preview={params?.voip_cert_url} />

      <Form.Item name='voip_cert_secret' label="Voip Password">
        <Input />
      </Form.Item>

      <h6 className="v-content-label o-sm">
        Push Certificate
      </h6>

      <FileDropzone name='push_cert' label='Push Cert' preview={params?.push_cert_url || undefined} />

      <Form.Item name='team_id' label="Apple Team ID">
        <Input placeholder="e.g. ABCD1234EF" />
      </Form.Item>

      <Form.Item name='apns_key_id' label="APNs Key ID">
        <Input placeholder="e.g. ABC123DEFG" />
      </Form.Item>

      <h6 className="v-content-label o-sm">
        StoreKit2 API Keys {' '}
        <a href="https://developer.apple.com/documentation/StoreKit/generating-jws-to-sign-app-store-requests#Get-your-key-ID-and-issuer-ID-from-App-Store-Connect" target="_blank" rel="noreferrer" style={{ fontWeight: 400 }}>
          docs
        </a>
      </h6>

      <FileDropzone name='app_store_connect_api_private_key' label='Private Key (.p8)' preview={params?.app_store_connect_api_private_key_url || undefined} />

      <Form.Item name='app_store_connect_api_key_id' label="Key ID">
        <Input />
      </Form.Item>

      <Form.Item name='app_store_connect_api_issuer_id' label="Issuer ID">
        <Input />
      </Form.Item>

      <Form.Item label="Environment" name='prod_env' valuePropName='checked'>
        <Switch
          checkedChildren='production'
          unCheckedChildren='development'
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
